import { registerModals } from '@core/modal/model/registerModals';
import { RemindMeSuccessModalLazy } from '@embed/components/VideoPlayer/Player3/components/LiveStreaming/RemindMe/RemindMe/RemindMeModal';
import { ModalCopy } from '@embed/components/VideoPlayer/Player3/components/modals/shared/ModalCopy';
import { SharePanel } from '@embed/components/VideoPlayer/Player3/components/modals/shared/SharePanel';
import { SubtitlesPanel } from '@embed/components/VideoPlayer/Player3/components/modals/shared/SubtitlesPanel';
import { EmailEmbedModal, IVSQualityModal, MainMenu, } from '@embed/components/VideoPlayer/Player3/components/modals/VideoSettingsMenu';
import { ConfirmLazy } from '@player/components/Modal/ConfirmLazy';
import { StreamPrepModalLazy } from '@player/features/guestSpeaker/components/StreamPrepModal';
import { StreamSettingModalLazy } from '@player/features/guestSpeaker/components/StreamSettingModal';
import { ChatSettingsModalLazy } from '@player/features/modal/components/ChatSettingsModal';
import { ErrorModalLazy } from '@player/features/modal/components/ErrorModal/ErrorModalLazy';
import { FullscreenProductDetailModalLazy } from '@player/features/modal/components/FullscreenProductDetailModal';
import { RenameModalLazy } from '@player/features/modal/components/RenameModal';
// TODO: migrate all modal types to this enum
export var PlayerModalType;
(function (PlayerModalType) {
    PlayerModalType[PlayerModalType["CONFIRM"] = 0] = "CONFIRM";
    PlayerModalType[PlayerModalType["ERROR"] = 1] = "ERROR";
    PlayerModalType[PlayerModalType["CHAT_USERNAME"] = 2] = "CHAT_USERNAME";
    PlayerModalType[PlayerModalType["CHAT_SETTINGS"] = 3] = "CHAT_SETTINGS";
    PlayerModalType[PlayerModalType["STREAM_PREP"] = 4] = "STREAM_PREP";
    PlayerModalType[PlayerModalType["STREAM_SETTING"] = 5] = "STREAM_SETTING";
    PlayerModalType[PlayerModalType["REMIND_ME"] = 6] = "REMIND_ME";
    PlayerModalType[PlayerModalType["FULLSCREEN_PRODUCT_DETAIL"] = 7] = "FULLSCREEN_PRODUCT_DETAIL";
    PlayerModalType[PlayerModalType["SUBTITLES"] = 8] = "SUBTITLES";
    // 3dot menu
    PlayerModalType[PlayerModalType["MAIN"] = 9] = "MAIN";
    PlayerModalType[PlayerModalType["SHARE"] = 10] = "SHARE";
    PlayerModalType[PlayerModalType["SHARE_COPY_MESSAGE"] = 11] = "SHARE_COPY_MESSAGE";
    PlayerModalType[PlayerModalType["EMAIL_EMBED"] = 12] = "EMAIL_EMBED";
    PlayerModalType[PlayerModalType["IVS_QUALITY"] = 13] = "IVS_QUALITY";
})(PlayerModalType || (PlayerModalType = {}));
export const { getModalComponent, selectors, createSlice } = registerModals({
    [PlayerModalType.CONFIRM]: ConfirmLazy,
    [PlayerModalType.ERROR]: ErrorModalLazy,
    [PlayerModalType.CHAT_USERNAME]: RenameModalLazy,
    [PlayerModalType.CHAT_SETTINGS]: ChatSettingsModalLazy,
    [PlayerModalType.STREAM_PREP]: StreamPrepModalLazy,
    [PlayerModalType.STREAM_SETTING]: StreamSettingModalLazy,
    [PlayerModalType.REMIND_ME]: RemindMeSuccessModalLazy,
    [PlayerModalType.FULLSCREEN_PRODUCT_DETAIL]: FullscreenProductDetailModalLazy,
    [PlayerModalType.SUBTITLES]: SubtitlesPanel,
    // 3dot menu
    [PlayerModalType.MAIN]: MainMenu,
    [PlayerModalType.SHARE]: SharePanel,
    [PlayerModalType.SHARE_COPY_MESSAGE]: ModalCopy,
    [PlayerModalType.EMAIL_EMBED]: EmailEmbedModal,
    [PlayerModalType.IVS_QUALITY]: IVSQualityModal,
});
